export default `
  query listWorkflows($projectId: String!, $limit: Int, $nextToken: String) {
    listWorkflows(projectId: $projectId) {
      project {
        workflows(limit: $limit, nextToken: $nextToken) {
          items {
            id
            projectId
            name
            starred
            version
            thumbnail
            updatedAt
            status
          }
          nextToken
        }
      }
    }
  }
`
